/* eslint-disable indent */
import { Form } from 'digicon-web-forms/forms';
import { createFields, createInfoField } from 'project/js/fieldsFactory';

export class FormsData {

	constructor(container, locale) {
		this.locale = locale;
		this.container = container;
	}

	setData(webForms) {
		this.data = structuredClone(webForms);
	}

	parseForms(fields, inverse = false) {
		for (const formData of this.data.forms) {
			if (inverse) {
				fields = this.createForm(formData).concat(fields);
			} else {
				fields = fields.concat(this.createForm(formData));
			}
		}
		const form = new Form({ containerId: this.container, fields: fields });
		this.form = form;
	}

	clear() {
		this.form = null;
	}

	createForm(data) {
		const fields = [];
		data.locale = this.local
		if (data.category_en != "") {
			fields.push(createInfoField(data));
		}
		for (const fieldData of data.form_data) {
			fieldData.group = data.category_en;
			fieldData.locale = this.locale;
			const newFields = createFields(fieldData, this.locale);
			if (newFields) {
				fields.push(...newFields);
			}
		}

		return fields;
	}

	setDataFieldValue(fieldId, value) {
		for (const form of this.data.forms) {
			const field = form.form_data.find(field => field.id === fieldId);
			if (field) {
				field.value = value;
				break;
			}
		}
	}

	getFormFieldValue(fieldId) {
		const value = this.form.getFormData()[fieldId];
		return value;
	}

	setFormFieldValue(fieldId, value) {
		this.form.setFieldValue(fieldId, value);
	}

	getFormData() {
		if (this.form) {
			const data = this.form.getFormData();
			return data;
		}
		return {};
	}

	updateFormFields(formData) {
		this.form.updateForm(formData);
	}
}